import './core/Sentry'
// nette
import './nette/NetteAutosubmit'
import './nette/NetteValidationMessages'

import { updateHistoryRecord } from 'swup'

import { loadComponents, removeComponents } from './core/componentUtils'
// set basepath of project for webpack
import { basePath } from './core/config'
import EventBus from './core/EventBus'
import { EVENTS } from './core/Events'
import TouchMouseInputResolver from './meta/TouchMouseInputResolver'
import Nette from './nette/NetteForms'
import { runLazyImages } from './services/LazyImages'
import NajaService from './services/Naja'
import ScrollService, { scrollToElement, setScrollPosition } from './services/Scroll'
import { scrollHistory } from './services/ScrollHistory'
import { runSwup } from './services/Swup'
import { runScriptsInsideElement } from './utils/script'

__webpack_public_path__ = `${basePath}/assets/frontend/js/`

window.Nette = Nette
Nette.initOnLoad()

NajaService.formsHandler.netteForms = Nette
NajaService.initialize()

new TouchMouseInputResolver()

ScrollService.useNative()
setScrollPosition()

loadComponents()

runLazyImages()

runSwup({
	ScrollService,
	EventBus,
	EVENTS,
	scrollToElement,
	loadComponents,
	removeComponents,
	scrollHistory,
	setScrollPosition,
	runScriptsInsideElement,
	NajaService,
})

window.addEventListener('toggleblock-change', (event) => {
	const { element, action } = event.detail
	if (action === 'open' && window.swup) {
		const url = new URL(window.location.origin + window.swup.getCurrentUrl())
		url.hash = element.id
		updateHistoryRecord(`${url.search}${url.hash}`)
	}
})
